import { cleanIntegrationWarningText, isMissingIntegrationWarning } from './sourceGapPolicy.js';

const directive = /\bUSE VALUE FROM STRUCTURED DATA\s*:?\s*/gi;
const warningOnly = (value: unknown) => typeof value === 'string' && isMissingIntegrationWarning(value) && !cleanIntegrationWarningText(value);

export function cleanReportPromptText<T>(value: T): T {
    if (typeof value === 'string') {
        const text = cleanIntegrationWarningText(value);
        if (!/USE VALUE FROM STRUCTURED DATA/i.test(text)) return text as T;
        const cleaned = text.replace(directive, '').trim();
        return (!cleaned || /(?:^|=|\$)\s*N\/A(?:%|\s*USD)?$/i.test(cleaned) ? 'Data unavailable' : cleaned) as T;
    }
    if (Array.isArray(value)) return value.filter(item => !warningOnly(item) && !warningOnly(item?.gap)).map(cleanReportPromptText) as T;
    if (value && typeof value === 'object' && Object.getPrototypeOf(value) === Object.prototype)
        return Object.fromEntries(Object.entries(value).filter(([key]) => !warningOnly(key))
            .map(([key, item]) => [key, cleanReportPromptText(item)])) as T;
    return value;
}
